import { SxcApp } from '@2sic.com/sxc-angular';
import { httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Categories, DownloadData } from '../downloads/downloadsModel';

@Injectable({
  providedIn: 'root',
})
export class DownloadApiService {
  constructor(private app: SxcApp) {}

  getCategories() {
    return httpResource<Categories[]>(() => ({
      url: this.app.api('Downloads').url('GetCategories'),
      method: 'GET',
      body: {},
    })).value;
  }

  getDownload() {
    return httpResource<DownloadData>(() => ({
      url: this.app.api('Downloads').url('Get'),
      method: 'GET',
      body: {},
    })).value;
  }
}
